import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InhousePharmacyDetails } from '@module-claims/models/pharmacy.interface';
import { ClaimsService } from '@module-claims/services/claims.service';
import { IAsyncData } from '@module-claims/store/claims.state';
import {
  InhousePharmacyModalClose,
  InhousePharmacyModalSave
} from '@module-claims/store/pharmacy.actions';

@Component({
  selector: 'app-inhouse-pharmacy-modal',
  templateUrl: './inhouse-pharmacy-modal.component.html',
  styleUrls: ['./inhouse-pharmacy-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InhousePharmacyModalComponent implements OnInit, OnDestroy {
  @Input() npi!: string;

  readonly destroy$ = new Subject();

  inhousePharmacyDetails$: Observable<IAsyncData<InhousePharmacyDetails>>;
  inhousePharmacyDetails?: InhousePharmacyDetails;
  form!: UntypedFormGroup;
  dateTimeFormat = 'M/d/yyyy h:mm a';
  lastSearchDate?: Date;
  searchSubmitted = false;

  constructor(
    private _claimsService: ClaimsService,
    private _fb: UntypedFormBuilder,
    private _store: Store,
    private _cdr: ChangeDetectorRef
  ) {
    this.inhousePharmacyDetails$ = this._claimsService.inhousePharmacyDetails$;

    this.inhousePharmacyDetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ data }) => {
        this.inhousePharmacyDetails = data;
      });
  }

  ngOnInit(): void {
    this._claimsService.clearInhousePharmacyDetails();
    this.initForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    this.close();
  }

  close(): void {
    this._store.dispatch(new InhousePharmacyModalClose());
  }

  save(): void {
    if (!this.inhousePharmacyDetails) {
      return;
    }

    this._store.dispatch(
      new InhousePharmacyModalSave({
        npi: this.npi,
        id340b: this.inhousePharmacyDetails.id340b,
        organization: this.inhousePharmacyDetails.ce_name,
        _row_hashtag_address: this.inhousePharmacyDetails._row_hashtag_address
      })
    );
  }

  getInhousePharmacyDetails(): void {
    const id340b = this.form.get('id340b')?.value;
    if (id340b) {
      this.searchSubmitted = false;
      this._claimsService.getInhousePharmacyDetails(id340b).subscribe(() => {
        this.searchSubmitted = true;
        this.lastSearchDate = new Date();
        this._cdr.detectChanges();
      });
    }
  }

  private initForm(): void {
    this.form = this._fb.group({
      id340b: [null]
    });
  }
}
